'use client';

import { ExperimentVersion } from '../types';
import { useExperimentValue } from './useExperimentValue';

export function useIsExperimentFullSolution() {
    return useExperimentValue() === ExperimentVersion.FULL_SOLUTION;
}
